// extracted by mini-css-extract-plugin
module.exports = {"modal-box":"iL","modalBox":"iL","modal-mask":"iM","modalMask":"iM","close-btn":"iN","closeBtn":"iN","container":"iO","content":"iP","title":"iQ","subTitle":"iR","detail":"iS"};